import React, { useState } from 'react';
import { bool, func, string } from 'prop-types';

import { connect } from 'react-redux';

import EsmsDialog from '../../components/EsmsDialog';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as ErpAgentActions from '../../actions/erpAgentActions';

import classes from './NewErpAgentCredentialsModal.module.css';

const NewErpAgentCredentialsModal = ({
    close,
    open,
    title,
    isLoading,
    clearErrors,
    serialNumber,
    authKey,
    errors,
    ...props
}) => {
    const [showKey, setShowKey] = useState(false);

    const handleClose = () => {
        clearErrors();
        close();
    };

    const toggleShowKey = (e) => {
        e.preventDefault();
        setShowKey(!showKey);
    };

    const downloadCredentialsCsv = (e) => {
        const csv = `serialNumber,authorizationKey\n${serialNumber},${authKey}\n`;
        let hiddenDownload = document.createElement('a');
        hiddenDownload.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
        hiddenDownload.target = '_blank';
        hiddenDownload.download = 'credentials.csv';
        hiddenDownload.click();
    };

    const handleReset = () => {};
    const isSubmitting = false;

    return (
        <EsmsDialog
            errors={errors}
            open={open}
            onClose={handleClose}
            title={title}
            onConfirm={downloadCredentialsCsv}
            onRendered={handleReset}
            disabled={isSubmitting}
            isLoading={isLoading}
            confirmText="Download Agent Credentials"
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
        >
            <div className={classes.formColumn}>
                <div className={classes.labelColumn}>
                    <div className={classes.labelHeader}>
                        <img src="/assets/images/lockFlat.svg" alt="lock icon" />
                        <span>Agent Credentials</span>
                    </div>
                    <div className={classes.labelContent}>
                        <p>
                            These credentials are required by the Signature Agent to authenticate with
                            your BOB Company. Please download a copy of these credentials and store
                            them in a secure location as they are only available for download once.
                        </p>
                        <p>
                            You will have the option to rotate your credentials from the FSM Integration
                            management page at any point.
                        </p>
                    </div>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <h3 className={classes.downloadHeaderText}>Serial Number</h3>
                        <p>{ serialNumber }</p>
                        <h3 className={classes.downloadHeaderText}>Authorization Key</h3>
                        <a href="/" onClick={toggleShowKey}>View Key</a>
                        {showKey &&
                        <p>{ authKey }</p>
                        }
                    </div>
                </div>
            </div>
        </EsmsDialog>
    );

};

NewErpAgentCredentialsModal.propTypes = {
    close: func.isRequired,
    open:  bool.isRequired,
    title: string.isRequired
};

const mapStateToProps = ({erpAgent, ...state}) => {
    const { newErpAgent } = erpAgent;
    let agentSerial;
    let agentPassword;

    if (newErpAgent) {
        agentSerial = newErpAgent.agentSerial;
        agentPassword = newErpAgent.agentPassword;
    }

    return {
        companyInfo:  state.companyInfo,
        errors:       state.messages.errors,
        isLoading:    state.ui.isLoading,
        serialNumber: agentSerial,
        authKey:      agentPassword
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...ErpAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(NewErpAgentCredentialsModal);
